import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';

import App from 'App';
import { SoftwareManagementApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/SoftwareManagementApiPaths';
import UnexpectedErrorPage from 'Feature/Common/UnexpectedError/UnexpectedErrorPage';
import Consts from 'Framework/Consts';
import { ApiPathManagerSetup } from 'Shared/ApiPaths/ApiPathManagerSetup';
import apiPathConfigs from 'Shared/Constants/apiPathConfigs';
import userConfigs from 'Shared/Constants/userConfigs';
import GTMInitializer from 'Shared/GoogleTagManager/GTMInitializer';
import InitialInsuranceModules from 'Shared/InsuranceModules/InitialInsuranceModules';
import InitialMenuCategories from 'Shared/MenuCategories/InitialMenuCategories';
import { CombineReducerInitializer } from 'Shared/Store/combineReducerInitializer';
import { listReducer } from 'Shared/Store/listReducer';
import InitialTranslation from 'Shared/Translation/InitialTranslation';
import { UserManagerInitializer } from 'Shared/User/Components/UserManagerInitializer';
import 'assets/css/style.min.css';

import 'assets/scss/style-custom.scss';
import 'assets/scss/style.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
UserManagerInitializer(userConfigs);
ApiPathManagerSetup(apiPathConfigs);

root.render(
  <BrowserRouter>
    <CombineReducerInitializer listReducers={listReducer}>
      <ErrorBoundary FallbackComponent={UnexpectedErrorPage}>
        <GTMInitializer />
        <InitialInsuranceModules />
        <InitialMenuCategories />
        <InitialTranslation
          resourcePath={
            Consts.env.REACT_APP_SOFTWARE_MANAGEMENT_APP_BASE_URL + SoftwareManagementApiPaths.Translation.GetAllJson
          }
        />
        <App />
      </ErrorBoundary>
    </CombineReducerInitializer>
  </BrowserRouter>
);
